import { Component, OnInit } from '@angular/core';
import { AbstractDataListComponent } from '@app/shared/component/app-data-list/AbstractDataListComponent';
import { AirportService } from '../../service/aiport.service';

@Component({
  selector: 'app-airport-data-list',
  templateUrl: './airport-data-list.component.html',
  styleUrls: ['./airport-data-list.component.scss']/* ,
  changeDetection: ChangeDetectionStrategy.OnPush*/
})
export class AirportDataListComponent extends AbstractDataListComponent implements OnInit {

  constructor(
    private airportService: AirportService,
    // public changeDetection: ChangeDetectorRef
  ) {
    // super(changeDetection, 20);
    super(null, 20);
  }

  ngOnInit(): void {
  }

  keySearchData(key: string): void {

    try {

      // cuando esté definido el servicio
      // this.searchObservableSubscribe(this.entityService.getKeyValuesFromKeySearchEntity(EntityCV.all.AIRPORT, key));

      // el mock por ahora
      this.searchObservableSubscribe(this.airportService.findKeyValueByKeyStartingWith(key), key);

    } catch (error) {
      throw new Error('DataList.component.keySearchData.error');
    }
  }

  valueSearchData(value: string): void {
    try {

      // cuando esté definido el servicio
      // this.searchObservableSubscribe(this.entityService.getKeyValuesFromValueSearchEntity(EntityCV.all.AIRPORT, value));

      // el mock por ahora
      this.searchObservableSubscribe(this.airportService.findKeyValueByByValueContaining(value), value);

    } catch (error) {
      throw new Error('DataList.component.keySearchData.error');
    }
  }

}
